import { ExtractedOrderData } from './funzingDataExtractor';

// Date format: DD-MM-YYYY
const DATE_RE = /(\d{2})-(\d{2})-(\d{4})/;
// Two times on the same date line: HH:MM - HH:MM (start is the earlier one)
const TIMES_RE = /(\d{2}:\d{2})\s*-\s*(\d{2}:\d{2})/;
// Customer phone (not the venue contact phone)
const CUSTOMER_PHONE_RE = /טלפון לקוח:\s*(\d+)/;
// First line: שלום <first> [middle] <last>
const NAME_RE = /^שלום\s+(.+)/m;

function earlierTime(a: string, b: string): string {
  return a < b ? a : b;
}

const EMPTY: ExtractedOrderData = {
  firstName: null,
  lastName: null,
  date: null,
  time: null,
  persons: null,
  phone: null,
  source: null,
};

export function extractOrderDataFromBasalon(text: string): ExtractedOrderData {
  const phoneMatch = text.match(CUSTOMER_PHONE_RE);
  const nameMatch = text.match(NAME_RE);
  if (!phoneMatch && !nameMatch) return EMPTY;

  const dateMatch = text.match(DATE_RE);
  const timesMatch = text.match(TIMES_RE);

  let firstName: string | null = null;
  let lastName: string | null = null;
  if (nameMatch) {
    const parts = nameMatch[1].trim().split(/\s+/);
    firstName = parts[0] ?? null;
    lastName = parts.length > 1 ? parts[parts.length - 1] : null;
  }

  let date: string | null = null;
  if (dateMatch) {
    const [, day, month, year] = dateMatch;
    date = `${year}-${month}-${day}`;
  }

  const time = timesMatch ? earlierTime(timesMatch[1], timesMatch[2]) : null;

  return {
    firstName,
    lastName,
    date,
    time,
    persons: null,
    phone: phoneMatch ? phoneMatch[1] : null,
    source: 'externalPrefill.sources.basalon',
  };
}
